module.exports = __webpack_public_path__ + "img/alert-triangle.a3d735c2.svg";